import { toast } from 'sonner';
import axiosInstance from '../axiosInstance';
import { financePath } from '../../../utils/financePath';

// Action Types
export const FETCH_PETTY_CASH_REQUEST = 'FETCH_PETTY_CASH_REQUEST';
export const FETCH_PETTY_CASH_SUCCESS = 'FETCH_PETTY_CASH_SUCCESS';
export const FETCH_PETTY_CASH_FAILURE = 'FETCH_PETTY_CASH_FAILURE';

export const CREATE_PETTY_CASH_REQUEST = 'CREATE_PETTY_CASH_REQUEST';
export const CREATE_PETTY_CASH_SUCCESS = 'CREATE_PETTY_CASH_SUCCESS';
export const CREATE_PETTY_CASH_FAILURE = 'CREATE_PETTY_CASH_FAILURE';

export const UPDATE_PETTY_CASH_REQUEST = 'UPDATE_PETTY_CASH_REQUEST';
export const UPDATE_PETTY_CASH_SUCCESS = 'UPDATE_PETTY_CASH_SUCCESS';
export const UPDATE_PETTY_CASH_FAILURE = 'UPDATE_PETTY_CASH_FAILURE';

export const DELETE_PETTY_CASH_REQUEST = 'DELETE_PETTY_CASH_REQUEST';
export const DELETE_PETTY_CASH_SUCCESS = 'DELETE_PETTY_CASH_SUCCESS';
export const DELETE_PETTY_CASH_FAILURE = 'DELETE_PETTY_CASH_FAILURE';

export const FETCH_PETTY_CASH_SUMMARY_REQUEST = 'FETCH_PETTY_CASH_SUMMARY_REQUEST';
export const FETCH_PETTY_CASH_SUMMARY_SUCCESS = 'FETCH_PETTY_CASH_SUMMARY_SUCCESS';
export const FETCH_PETTY_CASH_SUMMARY_FAILURE = 'FETCH_PETTY_CASH_SUMMARY_FAILURE';

// Fetch Petty Cash Transactions
export const Fetch_PettyCash =
  (params = {}) =>
    async (dispatch) => {
      dispatch({ type: FETCH_PETTY_CASH_REQUEST });

      try {
        const queryString = new URLSearchParams(params).toString();
        const response = await axiosInstance.get(financePath(`petty-cash?${queryString}`));

        dispatch({
          type: FETCH_PETTY_CASH_SUCCESS,
          payload: response.data.data
        });

        return response.data;
      } catch (error) {
        const errorMsg = error.response?.data?.error || 'Failed to fetch petty cash transactions';
        dispatch({
          type: FETCH_PETTY_CASH_FAILURE,
          payload: errorMsg
        });
        toast.error(errorMsg);
        throw error;
      }
    };

// Create Petty Cash Transaction
export const Create_PettyCash = (data) => async (dispatch) => {
  dispatch({ type: CREATE_PETTY_CASH_REQUEST });

  try {
    const response = await axiosInstance.post(financePath('petty-cash'), data);

    dispatch({
      type: CREATE_PETTY_CASH_SUCCESS,
      payload: response.data.data
    });

    toast.success('Petty cash transaction created successfully');
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to create transaction';
    dispatch({
      type: CREATE_PETTY_CASH_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Update Petty Cash Transaction
export const Update_PettyCash = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_PETTY_CASH_REQUEST });

  try {
    const response = await axiosInstance.put(financePath(`petty-cash/${id}`), data);

    dispatch({
      type: UPDATE_PETTY_CASH_SUCCESS,
      payload: response.data.data
    });

    toast.success('Petty cash transaction updated successfully');
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to update transaction';
    dispatch({
      type: UPDATE_PETTY_CASH_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Delete Petty Cash Transaction
export const Delete_PettyCash = (id) => async (dispatch) => {
  dispatch({ type: DELETE_PETTY_CASH_REQUEST });

  try {
    await axiosInstance.delete(financePath(`petty-cash/${id}`));

    dispatch({
      type: DELETE_PETTY_CASH_SUCCESS,
      payload: id
    });

    toast.success('Petty cash transaction deleted successfully');
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to delete transaction';
    dispatch({
      type: DELETE_PETTY_CASH_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Fetch Petty Cash Summary
export const Fetch_PettyCashSummary =
  (params = {}) =>
    async (dispatch) => {
      dispatch({ type: FETCH_PETTY_CASH_SUMMARY_REQUEST });

      try {
        const queryString = new URLSearchParams(params).toString();
        const response = await axiosInstance.get(financePath(`petty-cash/summary?${queryString}`));

        dispatch({
          type: FETCH_PETTY_CASH_SUMMARY_SUCCESS,
          payload: response.data.data
        });

        return response.data;
      } catch (error) {
        const errorMsg = error.response?.data?.error || 'Failed to fetch summary';
        dispatch({
          type: FETCH_PETTY_CASH_SUMMARY_FAILURE,
          payload: errorMsg
        });
        toast.error(errorMsg);
        throw error;
      }
    };